module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }), _c('div', {
    staticClass: "chapterHead"
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }), _c('h2', {
    staticClass: "chapterNumber"
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('span', {
    staticClass: "xrefInternal"
  })]), _c('a', {
    attrs: {
      "href": "#/9780061734106_contents#ch_02"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2")])])]), _vm._v(" "), _c('h2', {
    staticClass: "chapterTitle"
  }, [_c('span', {
    staticClass: "xrefInternal"
  }, [_c('a', {
    attrs: {
      "href": "#/9780061734106_contents#ch_02"
    }
  }, [_vm._v("THE FOLLOWING TAKES PLACE BETWEEN THE HOURS OF 6 A.M. AND 7 A.M. CENTRAL DAYLIGHT TIME")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterDateline"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Golden Pole, New Orleans")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapterOpenerText"
  }, [_vm._v("Vikki Valence’s apartment was like the dancer herself—flamboyant and overstuffed.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Jack was in the living room, holding his gun in a two-handed shooter’s grip, his knees bent in a combat crouch.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Behind him, the door to the balcony gaped open, hanging halfway off its hinges. It had been locked, compelling him to make a forced entry. A couple of stomp-kicks had done the trick.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Daylight shone through the open doorway, illuminating the cavelike dimness of the interior. The windows fronting the balcony were screened by both blinds and heavy drapes. Even the wan light of an early, overcast morning was a help.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Jack stood to one side of the open doorway, to avoid outlining himself in it and making a better target for anybody "), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("who might be lurking around inside. It seemed like the shooting was over, but…maybe not. Whoever was behind the attack on Paz might have decided to have Vikki taken care of at the same time.")])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Opposite the balcony door, on the far side of the living room, another door opened on a dark hallway inside the building. The door was partly ajar. As soon as he saw it, Jack figured that Vikki had fled that way, but he was taking nothing for granted. The apartment had to be cleared.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The premises showed all the signs of recent occupancy. The air conditioner was going full-blast. Coming in from the stifling heat and humidity outside, Jack could feel the sweat on his body turning cold.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The living room held a couch, several armchairs, and a coffee table. The plush couch was the size of a compact car; each plumply cushioned armchair looked big enough to swallow a medium-sized man. The furniture was festooned with lots of lacy black shawls and leopard-print coverlets.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The air was thick with the mingled scents of tobacco smoke, whiskey fumes, perfume, and sweat. The coffee table was crowded with bottles of booze, some empty, others half full; drinking glasses, an ice bowl, and a half-dozen or so bottles of club soda and tonic water for setups. Vikki and the Colonel must have had themselves quite a party.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The living room was empty of persons living or dead. To Jack’s right, a short hallway opened onto several rooms. Doors opened on the right and left; at the far end of the corridor lay the bedroom. With his leveled gun leading the way, he padded soft-footed into the passageway.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("On his left was a kitchenette. Jack looked in. There was a small, square table with a couple of straight-backed armless chairs, some cupboards, and a refrigerator sandwiched into an alcove. The sink and sideboard were covered with dirty dishes.")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("On the right was a bathroom. It was hot, steamy, cloyingly fragrant from the combined scents of dozens of bottles of creams, lotions, cosmetics, gels, hair sprays, and other beauty products. He looked behind the shower curtain to make sure nobody was hiding in the bathtub. Nobody was.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The inside of the shower curtain was dripping with moisture; the mirror over the sink was fogged with condensation, indicating that someone had taken a shower in it not long before. Vikki, the Colonel, or both.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A light showed in the bedroom, the glow of a bedside night-table lamp. The gun entered the room, Jack following it, moving light-footed, alert.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dominating the space was a big brass bed slightly smaller than Cleopatra’s barge, its pink satin sheets rumpled and sodden. Hanging on the wall above the ornate brass headboard was a painting of Vikki in the nude, all glossy pink and rendered on black velvet.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A flash of movement glimpsed in the corner of his eye jolted Jack, causing him to whip his gun around to cover it.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He realized that what he’d seen was merely his own reflection, imaged in a wall-length mirror. The looking glass was marbled with spidery gold veins. He grinned tightly, slowly letting out his breath.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He looked under the bed to make sure no one was hiding there. It was an old gag, one of the oldest in the book, but the reason it had lasted so long was that it worked. After the big gun-down outside, he wouldn’t have been surprised to find a body, alive or dead, but it came up blank.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A walk-in closet held racks of garments, dresses, blouses, skirts, lingerie. The floor was covered with massed ranks of women’s shoes. There was enough stuff inside there to stock a boutique, but no space for anybody to hide in.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("Jack gave the room a quick scan, looking for anything that might prove useful in tracking Vikki down: an address ")]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("book, diary, stack of letters, pocketbook, or anything along those lines. Later a CTU forensics team would go over the place with a fine-tooth comb. But he didn’t want to take a chance on overlooking something that might turn out to be a vital clue. Nothing relevant showed up during his swift survey.")])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("The main object of his search had been Vikki herself; his first impression was that she’d taken it on the run, but he had to be sure. He couldn’t afford to linger overlong in her apartment, but he couldn’t move on without clearing it.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Well, it had been cleared now. Jack retraced his steps, back into the living room. He crossed to the door opening onto the interior of the building, approaching it at an oblique angle that would keep him out of the firing line of any hostiles lurking on the landing.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Flattening his back against the wall, he used his foot to ease the door open all the way, then darted through the doorway.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He stepped into a long hallway, lined on both sides with closed doors. Sparsely placed ceiling lamps provided mini-mal illumination. The light was as murky as the waters of a fish tank that had gone too long without cleaning.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("There was a chance, a slim one, that Vikki had found shelter in a neighboring apartment, but Jack lacked the time or resources now to make a room-to-room search. Instinct told him it was unlikely she was still in the building. If she was somewhere on the premises, that’d be a break, because she could be picked up later when CTU reinforcements had arrived. He wasn’t counting on it, though.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Toward the front of the building was a landing and a stairwell. The stairs slanted down to a street-level door, the one used earlier by Paz when he’d stepped out onto the sidewalk and set off the fireworks.")])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("In the opposite direction, toward the rear of the building, a second set of stairs led to a ground-floor back door. Outside, Pete Malo was covering that one, though it was probably a case of locking the barn door after the horse had vamoosed.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Jack made for the front stairs. Ahead, on the left, a door suddenly opened and a man stepped out onto the landing. Jack leveled the gun at him.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The other saw him at the same time. He was a fat man in a sleeveless undershirt and a pair of pants with suspenders. The suspenders were unfastened and hung in loops at his sides. His bare feet were stuffed into a pair of flip-flops.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He lurched, recoiling, the floorboards groaning under his weight. He threw up his arms in a hands-up position. His hands were empty of weapons. He cried, “Don’t shoot!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He goggled at the gun. Fear had drained the color from his face, leaving it white and pasty as baker’s dough.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Jack moved closer, keeping him covered. He asked, “Who’re you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Shelburne! Drake Shelburne!” The fat man quivered, triple chins bobbing as he gasped for breath. “I’m the manager here!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Where’s Vikki Valence?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I don’t know!” Then, after a pause, he added, “I should have known she’d be mixed up in this!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Jack said, “Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“The company she keeps, playboys and artists and foreigners and I don’t know what-all!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Jack wagged the gun barrel, indicating the door through which Shelburne had just emerged. “That your place?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Yessir!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Go back inside and stay there.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Shelburne still had his hands up. “Jeez, you like to give me a heart attack, waving that gun around—I’m going now, I’m just letting you know so you won’t shoot—”")])]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“Move!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’m moving, Oh Lordy, here I go—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Shelburne edged back into his room, pausing at the threshold. He’d recovered enough nerve to ask, “Say, what’s it all about, anyway?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Police business,” Jack said, figuring that that was the kind of answer that the manager of a strip club like the Golden Pole would understand. “Go inside and stay there until you’re told otherwise.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’m cooperating,” Shelburne said over his shoulder as he waddled back inside his room, closing the door behind him. Not slamming it but easing it into place. A cautious man.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Jack descended the stairs and exited through the side door onto Fairview Street.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The scene was the same as when he’d left it. Littered with corpses. The two bodyguards, Baca and Espinosa, lay sprawled on the sidewalk; the five attackers, Herm, Dixie, and the three shooters from the back of the truck, were strewn about the street.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Seven dead. Quite a body count, even for New Orleans, the new-crowned murder capital of the United States.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("So much for keeping a low profile to avoid scaring off Beltran.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The air was so still and dead that a pall of gun smoke still hazed the street, hovering motionlessly a few feet above the pavement, undisturbed by even the slightest breath of a breeze.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("At the south end of Fairview, a pickup truck rolled west on Bourbon Street, the driver oblivious to the carnage. On the far side of the square, a handful of people stood together in a clump, peering and gawking at the gunfight site. Civilians, spectators. The curious.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("Jack looked around, catching sight of Pete Malo standing north on Fairview, near the rear of the club. Earlier Jack had ")]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_vm._v("gone up the balcony stairs to check on Vikki’s apartment, while Pete stayed at street level, covering the club’s side and back doors.")])]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Jack fitted his gun back into the shoulder holster and went to the other. Pete said, “Vikki?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Jack shook his head no. “Gone.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I figured as much. Our bird has flown the coop,” Pete said. “She was already plenty jittery—on the tape of her call to the CTU hotline, she sounded spooked, scared. When the shooting started, she must’ve jumped like a scalded cat and hightailed it out of there.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He gestured toward the back of the building, where a brown-painted metal door was connected by three stone steps to an alley that met it at right angles. “Probably went out the back door,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Jack said, “Let’s hope so. At least that puts her in the opposite direction from Colonel Paz. It might not go so well for her if he should bump into her now—he might think she set him up for the slaughter. We know better—why contact CTU if the object was to lure Paz into a death trap?—but he doesn’t know that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Pete said, “The Colonel’s a hard man to kill. The machine gun in the briefcase was a neat trick.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“One we missed.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Pete indicated the corpses in the street. “Better them than us.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Jack said, “Cal Randolph may have a different opinion on that score.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Randolph was Director of CTU’s Gulf Coast Regional Center, the branch office located in the New Orleans area. Pete worked for him out of GCR Center. Jack worked out of CTU Los Angeles, but was on assignment here for the Beltran case.")])]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Pete made a sour face. “Cal’s been notified. I already talked to him and told him what happened.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Jack said, “How’d he take it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“About as well as you’d think. He’s got a bloodbath before breakfast, and our lead to Beltran is gone, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Maybe not. Vikki Valence isn’t exactly inconspicuous. She’ll have a tough time blending in with the woodwork,” Jack said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Pete said, “She doesn’t drive, either—at least our preliminary background check revealed no driver’s license or car registration in her name.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Jack said, “That’s something, anyway.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Pete’s expression was doubtful. “Trouble is, Vikki’s been around. She knows her way around the Quarter. And a gal like her has plenty of friends she can lay up with—men friends—not to mention those who’d like to be her friend.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Jack made a quick decision. “If she’s on foot, she may not have gotten very far. Maybe I can spot her hanging around in the vicinity. It’s worth a try, anyway. Let me have the keys to the SUV.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Pete said, “I’ll go. I know these streets a lot better than you do, Jack. This is my town.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You also know the local lawmen better, too. It’s best that they see a familiar face when they show up here. I’m a stranger to them, and a massacre is no place to strike up an acquaintanceship.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Speaking of which, I’d have thought that the cops would be here by now,” Jack added.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_vm._v("“You would—being an out-of-towner,” Pete said. “Truth to tell, our New Orleans Police Department falls a long way off from being in the front ranks of law enforcement. With a storm coming—a big one, from the looks of it—there’s already been a lot of absenteeism on the force. A number ")]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_vm._v("of the fellows don’t want to be trapped here in the city if another one like Katrina hits.”")])]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("He fished the car keys out of his pants pocket and tossed them to Jack, who snagged them out of the air. “Okay, Jack, you win.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’ll cruise around and see if I can pick up her trail,” Jack said. “Or Paz’s.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Good luck. I’ll hold down the fort here,” Pete said.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("Standard security precautions dictated that their CTU-issued vehicle not be parked on the same street where Paz’s bodyguards had kept their all-night vigil. They might have noticed it and become suspicious. Instead it stood on the next street running east of Fairview and parallel to it.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Jack cut through an alley to reach it, a passageway so narrow he could barely go through it without his shoulders brushing the walls.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The machine was there, right where they’d left it hours before on Friday night, parked at curbside on the west side of the street. A dark green SUV with a souped-up V–8 engine, bulletproof glass, armor-plated hull, reinforced chassis and suspension to carry the extra weight, and puncture-proof tires, solid all the way through. Plus an onboard wireless computer, satellite-phone communications capability, and an array of high-tech electronics hardware.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The vehicle was protected by an invisible, electromagnetic web woven by the sensors of a silent alarm system. So sophisticated were its threshold parameters that it could distinguish between random bumps and jostles such as any car might sustain when parked on a city street, as opposed to a deliberate attempt to tamper with the vehicle. In case of the latter, it would activate a receiver in the driver’s handheld keying device, notifying him of the attempted breach.")])]), _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("No such alarm had been tripped during the night watch. Jack switched on the keying device, electronically unlocking the car.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He opened the door, stepping into a blast of heat. The SUV had been locked up tight all night, windows sealed shut. Inside it felt as hot as a pizza oven.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Jack, dehydrated and gasping, fired up the engine. It started right up, with a thrum of power. Smooth and potent. He lowered the windows to let out some of the heat and turned the air conditioner on full blast.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He angled the SUV out from between the two cars it was parked between and into the street. He turned right at the corner, going east along Bourbon, rolling past Fairview Street and the Golden Pole.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He cruised along, his search pattern an ever-expanding spiral whose center was the club building. Sticking his head out the open window on the driver’s side, he peered into cross alleys, low-walled courts, recessed doorways, and similar places that offered cover to a fugitive.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He had two goals. Vikki was his primary objective, but he also kept an eye out for Paz. The Colonel had fled the scene on foot, too. He’d made his way south of the club, across Bourbon Street and beyond. Vikki had begun her flight by heading north.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He used his scrambled, comm-secure cell phone to contact CTU Gulf Coast Regional.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_vm._v("The Center was sited outside the city proper, New Orleans being a below-sea-level bowl bordered on the north by Lake Pontchartrain and the south by the Mississippi River. The facility was south of the river on the opposite shore, safely planted on high ground in Algiers, avoiding the danger of being trapped in the flooded bowl of the city, in the event of a reprise of an event like Katrina. A point that had ")]), _c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_vm._v("now become more than academic, with Hurricane Everette churning its way across the Gulf on a course that was New Orleans–bound.")])]), _c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("He drove with one hand on the wheel, the other holding the cell to the side of his head, his head craning out the open window, peering up and down various side streets, alleys, and footpaths in search of Vikki or Paz.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Jack Bauer here.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A comm-sys operator at CTU GCR Center said, “Your call is being switched to Director Randolph.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Jack hadn’t requested to speak to Randolph, he was just reporting in, but Randolph had some ideas of his own. The director was already up to speed on the Golden Pole massacre, having already been briefed by Pete Malo.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Randolph said, “We’ve got a forensics team and every available backup unit dispatched to the scene. They’ll be there any minute now.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“They’ll be needed. It’s one unholy mess out there.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What happened, Jack? How do you read it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Somebody tried to liquidate Paz and botched the job. It was a professional job, a pretty slick setup. Unfortunately for them, Paz was slicker. And they had the bad luck to shoot their move when Pete and I were on the scene. They didn’t know we were there, and got caught in a crossfire between us and Paz.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Randolph tsk-tsked. “Lord! This is the kind of thing you expect to find in Iraq or some banana republic, not in the United States of America. New Orleans is already on edge that Everette’s going to swat it. An incident like this—well, it’s the last thing we or the city needs right now.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Jack said, “I guess there’s never a good time for a massacre.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“It’s going to raise a big stink, Jack.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Maybe the storm will wash it away.”")])])]), _c('a', {
    attrs: {
      "id": "page40"
    }
  })]), _c('a', {
    attrs: {
      "id": "page40"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75928896","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780061734106_chapter_02.vue
// module id = 75
// module chunks = 0